import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, resolveHomeRoute } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'
import formsTable from './routes/forms-tables'
import others from './routes/others'
import organization from './routes/organization'
import habit from './routes/habit'
import privacy from './routes/privacy'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'auth-login' } },
    ...apps,
    ...organization,
    ...habit,
    ...privacy,
    ...dashboard,
    ...pages,
    ...chartsMaps,
    ...formsTable,
    ...uiElements,
    ...others,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

const pagesUserNotLogged = new Set(['auth-login', 'auth-forgot-password', 'auth-reset-password', 'error-404', 'employee-survey', 'complaint-new', 'complaint-follow-up', 'presence-validation', 'inactive-account', 'arsopbl-new', 'arsopbl-follow-up'])

router.beforeEach((to, from, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (isLoggedIn) {
    // If logged in and can't navigate => not authorized
    if (!canNavigate(to)) return next({ name: 'misc-not-authorized' })

    // Routes restricted to the consultant privilege only
    if (to.meta.requiresConsultant) {
      const { role } = store.state?.userStore?.userData || {}
      if (role !== 'consultant') return next({ name: 'misc-not-authorized' })
    }

    // Capa 1 (permisos granulares): cada ruta migrada declara meta:{module,action} y el
    // guard lee userData.permissions[module][action].allowed, fusionado en Login.vue desde
    // permission_default. Rutas sin este meta no se ven afectadas — se migran módulo a módulo.
    if (to.meta.module && to.meta.action) {
      const { permissions } = getUserData() || {}
      const isAllowed = permissions?.[to.meta.module]?.[to.meta.action]?.allowed
      if (!isAllowed) return next({ name: 'misc-not-authorized' })
    }

    // If client is inactive => send to inactive client page
    const clientStatus = JSON.parse(localStorage.getItem("clientData") || '{}').status
    if (clientStatus === 'inactive') {
      if (!pagesUserNotLogged.has(to.name)) {
        return next({ name: 'inactive-account' })
      }
    }
    // Else redirect to the client home page if the route has the 'redirectIfLoggedIn' property set to true
    else if (to.meta.redirectIfLoggedIn) {
      return next(resolveHomeRoute())
    }
  }
  else if (!pagesUserNotLogged.has(to.name)) {
    // Redirect to login if not logged in, storing the actual path to redirect afterwards
    const actualPath = window.location.pathname;
    return next({ name: 'auth-login', query: { from: actualPath } });
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
